export function jumpToCourse({courseId, distributionId, inviteUserId } : any) {
  return `${process.env.VUE_APP_BT_CLASS_URL}/course/${courseId}/detail?distributionId=${distributionId}&inviteUserId=${inviteUserId}`
}